import React from 'react';
import PropTypes from 'prop-types';
// Components
import iconSrc from '../../utils/iconSrc';
// Styles
import { InlineBanner, TextWrapper, BannerSVG } from './styles';
import { Container } from '../styled/containers';
import { useLayout } from '../layout/context';

const InlineCallOut = ({
  icon,
  forwardedRef,
  borderColor,
  bannerColor,
  children,
  removeMarginBottom,
  ...rest
}) => {
  const { insideContainer } = useLayout();

  return (
    <Container {...rest} $padding={!insideContainer} ref={forwardedRef}>
      <InlineBanner
        $borderColor={borderColor}
        $bannerColor={bannerColor}
        $removeMarginBottom={removeMarginBottom}
      >
        {icon && <BannerSVG src={iconSrc(icon)} cacheRequests />}
        <TextWrapper>{children}</TextWrapper>
      </InlineBanner>
    </Container>
  );
};

InlineCallOut.propTypes = {
  icon: PropTypes.string,
  borderColor: PropTypes.oneOf([
    'red',
    'grey',
    'warning',
    'quick-exit-blue',
    'facebook-blue',
    'twitter-blue',
    'whatsapp-green',
  ]),
  bannerColor: PropTypes.oneOf(['grey', 'white', 'transparent']),
  forwardedRef: PropTypes.object,
  children: PropTypes.any,
  removeMarginBottom: PropTypes.bool,
};

InlineCallOut.defaultProps = {
  removeMarginBottom: false,
  borderColor: 'red',
  bannerColor: 'grey',
};

export default InlineCallOut;
